import { Box, Button, Checkbox, Link, Typography } from '@mui/material';
import React, { useState } from 'react';
import { ButtonsContainer, VerificationContainer } from '../VerificationCode/styles';
import { useAuth } from '../../../Contexts/AuthContext';

export const AcceptTerms = ({ }) => {

    const { acceptedTerms, isLoading } = useAuth();

    const [accepted, setAccepted] = useState(false);

    const handleSubmit = async () => {
        await acceptedTerms({ accepted });
    }

    return (
        <VerificationContainer>
            <h1>Atenção</h1>
            <p>Para acessar, por favor aceite os termos de uso.</p>
            <Typography mt={2} >
                <Checkbox 
                    checked={accepted} 
                    onChange={e => setAccepted(odlAccepted => !odlAccepted)} 
                    sx={{ p: 0 }} 
                /> li e estou de acordo com os 
                <Link color="#b79568!important" target='_blank' href='https://valutpublicstorage.blob.core.windows.net/carteira/termo_uso_carteira_digital.pdf'><br />Termos e condições de uso</Link>
            </Typography>
            <ButtonsContainer>
                <Button
                    variant='contained'    
                    disabled={!accepted || isLoading}
                    onClick={handleSubmit}
                >
                    Continuar
                </Button>
            </ButtonsContainer>
        </VerificationContainer>
    )
}